





























import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'
import createDeliveryStore from '@/stores/CreateDeliveryStore'

@Component
export default class DeliveriesTableHeader extends Vue {
  @Prop(String)
  value: string

  @Prop(String)
  title: string

  createDeliveryStore = createDeliveryStore

  routes = Routes

  get isShowTitle(): boolean {
    return this.$route.name === Routes.deliveries
  }

  public emitInput(value: string) {
    this.$emit('input', value)
  }

  public clearNewDeliveryForm() {
    this.createDeliveryStore.setClearModel()
  }
}
